import { therapyPlanningAction } from 'src/redux/actions/constant';

const {
  GET_PDPM_FEATURE_TOGGLE_SUCCESS,
  GET_PDPM_FEATURE_TOGGLE_FAILURE,
  GET_PDPM_FEATURE_TOGGLE_LOADING,
} = therapyPlanningAction;

const intialState: object = {
  isError: false,
  errorMessage: '',
  response: null,
  loading: false,
};

export const getPdpmFeatureToggleReducer = (state = intialState, action: any) => {
  switch (action.type) {
    case GET_PDPM_FEATURE_TOGGLE_SUCCESS: {
      return {
        ...state,
        response: action.payload,
        isError: false,
        errorMessage: '',
        loading: false,
      };
    }
    case GET_PDPM_FEATURE_TOGGLE_FAILURE: {
      return {
        ...state,
        isError: true,
        errorMessage: action.payload,
        response: null,
        loading: false,
      };
    }
    case GET_PDPM_FEATURE_TOGGLE_LOADING: {
      return {
        ...intialState,
        loading: true,
      };
    }
    default:
      return state;
  }
};